var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoto = function SvgPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3729 7.29169C15.4218 7.29169 16.2722 6.44136 16.2722 5.39243C16.2722 4.34349 15.4218 3.49316 14.3729 3.49316C13.324 3.49316 12.4736 4.34349 12.4736 5.39243C12.4736 6.44136 13.324 7.29169 14.3729 7.29169Z",
    stroke: "#919191",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.20711 10.1022C3.81658 10.4927 3.18342 10.4927 2.79289 10.1022C2.40237 9.71169 2.40237 9.07853 2.79289 8.688L4.20711 10.1022ZM7.27547 7.77697L6.56851 8.48422L6.56836 8.48407L7.27547 7.77697ZM2.79289 8.688L4.41104 7.06986L5.82525 8.48407L4.20711 10.1022L2.79289 8.688ZM4.41104 7.06986C5.39729 6.08361 6.99633 6.08361 7.98258 7.06986L6.56836 8.48407C6.36316 8.27887 6.03045 8.27887 5.82525 8.48407L4.41104 7.06986ZM7.98243 7.06971L12.1388 11.2244L10.7249 12.6389L6.56851 8.48422L7.98243 7.06971Z",
    fill: "#919191"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49409 14.7555L13.269 10.9806C13.8647 10.3848 14.8306 10.3848 15.4263 10.9806L19.0003 14.5545V16.7118C19.0003 17.9756 17.9758 19 16.7121 19L3.28818 19C2.02445 19 1 17.9756 1 16.7118L1 3.28786C1 2.02414 2.02445 0.999685 3.28818 0.999685L16.7121 0.999685C17.9758 0.999685 19.0003 2.02414 19.0003 3.28786L19.0003 9.8473",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPhoto;